<template>
  <div v-if="edition.isArchive" class="archive-notice" role="note">
    <span class="pi pi-history" aria-hidden="true"></span>
    <span>{{ $t('pastEditions.archiveNotice', { year: edition.year }) }}</span>
    <a :href="currentUrl" class="archive-link">{{ $t('pastEditions.goToCurrent') }}</a>
  </div>
</template>

<script>
import { CURRENT_YEAR, EDITION_KEY, editionUrl } from "@/editions";

export default {
  name: "ArchiveNotice",
  inject: {
    edition: { from: EDITION_KEY },
  },
  computed: {
    currentUrl() {
      return editionUrl(CURRENT_YEAR);
    },
  },
};
</script>

<style scoped>
.archive-notice {
  position: relative;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 12px;
  padding: 10px 16px;
  font-family: var(--font-mono);
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-panel);
  border-bottom: 1px solid var(--accent-primary);
  text-align: center;
}

.archive-notice .pi {
  color: var(--accent-primary);
}

.archive-link {
  color: var(--accent-primary);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.archive-link:hover,
.archive-link:focus-visible {
  color: var(--accent-neon);
}
</style>
